import PropTypes from 'prop-types';
var nullableBoolean = (props, propName) => props[propName] === null ? null : PropTypes.bool;
var nullableString = (props, propName) => props[propName] === null ? null : PropTypes.string;
var CommonPropTypes = Object.freeze({
  nullableBoolean,
  nullableString
});
export default CommonPropTypes;
//# sourceMappingURL=CommonPropTypes.js.map